import { type RootState } from "~/app/store";
import { type LineItem } from "~/features/cart/cart/models/CartData";
import { selectLineItemsByProduct } from "~/features/cart/cart/redux/selectors/cartSelectors";
import { createSelector } from "reselect";
import { isConfiguratorProduct } from "~/domains/product/types/ProductData";
import * as PriceUtils from "~/utils/PriceUtils";
import {
  lineItemHasSurcharge,
  lineItemHasTariffSurcharge,
} from "~/features/cart/cart/redux/selectors/productEntrySelectors";
import {
  getSurchargeValueFromTotalPrice,
  getTotalPriceForLineItem,
} from "~/domains/product/utils/productDescriptorUtils";

export const selectLinearProductAmount = createSelector(
  (state: RootState) => state.products.basic,
  selectLineItemsByProduct,
  (products, lineItemsByProduct) => {
    return Object.keys(lineItemsByProduct).filter((productCode) => isConfiguratorProduct(products[productCode])).length;
  },
);
export const selectCartProductAmount = createSelector(
  selectLineItemsByProduct,
  (lineItemsByProduct) => Object.values(lineItemsByProduct).length,
);
export const selectCartContainsSurcharge = createSelector(
  (state: RootState) => state.cart.packageEntriesById,
  (packageEntriesById) => (Object.values(packageEntriesById) as LineItem[]).some(lineItemHasSurcharge),
);

export const selectCartContainsTariffSurcharge = createSelector(
  (state: RootState) => state.cart.packageEntriesById,
  (packageEntriesById) => (Object.values(packageEntriesById) as LineItem[]).some(lineItemHasTariffSurcharge),
);

export const selectCartSurcharge = createSelector(
  (state: RootState) => state.cart.packageEntriesById,
  (state: RootState) => state.products.basic,
  (packageEntriesById, basic) => {
    return PriceUtils.volatileSum(
      ...(Object.values(packageEntriesById) as LineItem[]).filter(lineItemHasSurcharge).map((lineItem) => {
        const isSubscription = !(basic[lineItem.productCode]?.quantityVisible ?? true);
        const totalPrice = getTotalPriceForLineItem(lineItem, isSubscription);
        return getSurchargeValueFromTotalPrice(totalPrice);
      }),
    );
  },
);
